// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__KuT-s","sidebar":"Layout_sidebar__2EpYu","sidebar-sticky":"Layout_sidebar-sticky__3s98E","sidebar-heading":"Layout_sidebar-heading__3ytDk"};